import ProductsList from '../../components/ProductsList'

import {
    useGetActionGamesQuery,
    useGetFightGamesQuery,
    useGetRpgGamesQuery,
    useGetSimulationGamesQuery,
    useGetSportGamesQuery
} from '../../services/api'

const Categories = () => {
    const { data: actionGames, isLoading: isLoadingAction } =
        useGetActionGamesQuery()
    const { data: fightGames, isLoading: isLoadingFight } =
        useGetFightGamesQuery()
    const { data: rpgGames, isLoading: isLoadingRPG } = useGetRpgGamesQuery()
    const { data: simulationGames, isLoading: isLoadingSimulation } =
        useGetSimulationGamesQuery()
    const { data: sportGames, isLoading: isLoadingSports } =
        useGetSportGamesQuery()

    return (
        <>
            <ProductsList
                games={actionGames}
                title="Ação"
                background="black"
                id="action"
                isLoading={isLoadingAction}
            />
            <ProductsList
                games={sportGames}
                title="Esportes"
                background="gray"
                id="sports"
                isLoading={isLoadingSports}
            />
            <ProductsList
                games={fightGames}
                title="Luta"
                background="black"
                id="fight"
                isLoading={isLoadingFight}
            />
            <ProductsList
                games={rpgGames}
                title="RPG"
                background="gray"
                id="rpg"
                isLoading={isLoadingRPG}
            />
            <ProductsList
                games={simulationGames}
                title="Simulação"
                background="black"
                id="simulation"
                isLoading={isLoadingSimulation}
            />
        </>
    )
}

export default Categories
